import React, {ReactNode} from 'react';
import {createPortal} from 'react-dom';
import {useTranslation} from 'react-i18next';
import {Button, Popup} from '@tickchak/react-share/app';
import {TShow} from '../../../../hooks/useShow';
import {useETicketDir} from '../../hooks/useETicketDir';
import * as css from './SheetShell.css';

interface SheetShellProps {
    show: TShow;
    title: string;
    children: ReactNode;
    'data-cy'?: string;
}

function SheetShell({show, title, children, 'data-cy': dataCy}: SheetShellProps): React.ReactElement {
    const {t} = useTranslation('eTicket');
    const {dir} = useETicketDir();

    // Portal to <body> so the popup escapes the carousel card, which is scaled with a CSS transform
    // (a transform makes the card the containing block for the fixed popup and its overflow clips it).
    // Because the portal also escapes the stage's dir, re-apply the order's direction on the panel.
    return createPortal(
        <Popup show={show} data-cy={dataCy}>
            <css.panel dir={dir}>
                <css.handle aria-hidden />
                <css.title>{title}</css.title>
                {children}
                <css.footer>
                    <Button variant="primary" size="primary" onClick={show.close} data-cy={`${dataCy}-close`}>
                        {t('close')}
                    </Button>
                </css.footer>
            </css.panel>
        </Popup>,
        document.body
    );
}

export default SheetShell;
